module.exports = __webpack_public_path__ + "static/media/micro-2.07eba13f.svg";